import axios from "axios";
import { create } from "zustand";

const productStore = create((set) => ({
  mProduct: null,
  product: null,
  isLoading: true,

  fetchNewProduct: async () => {
    // Fetch product
    const res = await axios.get("/site/fetch-new-product");
    // set product to state
    set({ product: res.data.product });
  },

  fetchAllProduct: async () => {
    // Fetch product
    const res = await axios.get("/site/fetch-all-product");
    // set product to state
    set({ mProduct: res.data.product });
    set({ isLoading: false });
  },

  fetchOneProduct: async ({ _id }) => {
    // fetch product
    const res = await axios.get(`/site/fetch-one-product/${_id}`);
    // return data
    return res.data.product;
  },
}));

export default productStore;
